import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { WarningIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DraftNotSaved() {
  const tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "hubspot-prosemirror.tooltips.draftNotSaved"
  });
  return /*#__PURE__*/_jsx(IconButton, {
    tooltip: tooltip,
    use: "transparent",
    placement: "top",
    "data-test-id": "draft-not-saved",
    children: /*#__PURE__*/_jsx(WarningIcon, {
      color: "fill-alert-default"
    })
  });
}